import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IJobRepository } from "@domain/repositories";
import { PagedBatchList, PagedJobList, RawFile, JobPipelineStepDetail, PagedBatchRawFileList, AuditingFile, Job, Step } from "@domain/schemas/BI";
import type { MergeNodePoolOption } from "@domain/valueObjects";

@injectable()
export class ListJobsService {
  @inject(TYPES.IJobRepository)
  private _jobRepository!: IJobRepository;

  async getJobByIDAsync(jobId: string): Promise<Job> {
    return this._jobRepository.getJobByIDAsync(jobId);
  }
  async deleteJobByIDAsync(jobId: string): Promise<Job> {
    return this._jobRepository.deleteJobByIDAsync(jobId);
  }
  async cancelPendingBatchesByJobIDAsync(jobId: string): Promise<Job> {
    return this._jobRepository.cancelPendingBatchesByJobIDAsync(jobId);
  }
  async abortJobByIDAsync(jobId: string): Promise<Job> {
    return this._jobRepository.abortJobByIDAsync(jobId);
  }
  async resumeJobByIDAsync(jobId: string): Promise<Job> {
    return this._jobRepository.resumeJobByIDAsync(jobId);
  }
  async getStepByIDAsync(stepId: string): Promise<Step> {
    return this._jobRepository.getStepByIDAsync(stepId);
  }
  async getAvailableMergeNodePoolsAsync(): Promise<MergeNodePoolOption[]> {
    return this._jobRepository.getAvailableMergeNodePoolsAsync();
  }
  async getJobListAsync(page?: number, pageSize?: number, sortBy?: string, sortDirection?: string, name?: string, createdBy?: string): Promise<PagedJobList> {
    return this._jobRepository.getListAsync(page, pageSize, sortBy, sortDirection, name, createdBy);
  }
  async getJobStepListAsync(jobId: string): Promise<JobPipelineStepDetail[]> {
    return this._jobRepository.getJobStepListAsync(jobId);
  }
  async getJobStepBatchListAsync(jobId: string, jobPipelineStepId: string): Promise<PagedBatchList> {
    return this._jobRepository.getJobStepBatchListAsync(jobId, jobPipelineStepId);
  }
  async getJobBatchSampleListAsync(jobId: string, jobPipelineStepId: string, batchId: string): Promise<PagedBatchRawFileList> {
    return this._jobRepository.getJobBatchSampleListAsync(jobId, jobPipelineStepId, batchId);
  }
  async startLogsAudit(jobId: string, jobPipelineStepId: string, batchId: string, sessionId: string): Promise<AuditingFile> {
    return this._jobRepository.startAuditLogs(jobId, jobPipelineStepId, batchId, sessionId);
  }
  async stopLogsAudit(jobId: string, jobPipelineStepId: string, batchId: string, sessionId: string): Promise<AuditingFile> {
    return this._jobRepository.stopAuditLogs(jobId, jobPipelineStepId, batchId, sessionId);
  }
  async getResults(jobId: string, jobPipelineStepId: string, batchId: string, sessionId: string): Promise<AuditingFile> {
    return this._jobRepository.getResults(jobId, jobPipelineStepId, batchId, sessionId);
  }
  async getSampleListAsync(sampleIds: string[]): Promise<RawFile[]> {
    return this._jobRepository.getSampleListAsync(sampleIds);
  }
}
